























































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { CredentialsType } from '@/api/types'
import { InputSelectOption } from '@/helpers/options'
import AnimateFade from '@/components/animation/AnimateFade.vue'
import ActivationModal from '@/views/Company/Settings/SmartMarketing/ActivationModal.vue'
const smartMarketing = namespace('smartMarketing')

@Component({
    components: {ActivationModal, AnimateFade},
})
export default class CompanySettingsSmartMarketingGeneral extends Vue {
    @smartMarketing.State readonly activating!: boolean
    @smartMarketing.State readonly validating!: boolean
    @smartMarketing.State readonly valid!: boolean
    @smartMarketing.State readonly enabled!: boolean
    @smartMarketing.State readonly credentialsType!: CredentialsType
    @smartMarketing.State readonly apiUrl!: string|null
    @smartMarketing.State readonly apiKey!: string|null
    @smartMarketing.Getter readonly supportedPlatforms!: CredentialsType[]
    @smartMarketing.Getter readonly canActivate!: boolean
    @smartMarketing.Getter readonly isActivated!: boolean
    @smartMarketing.Getter readonly isActiveCampaign!: boolean
    @smartMarketing.Action readonly updateEnabled!: (enabled: boolean) => Promise<void>
    @smartMarketing.Action readonly updateCredentialsType!: (credentialsType: CredentialsType) => Promise<void>
    @smartMarketing.Action readonly updateApiUrl!: (apiUrl: string) => Promise<void>
    @smartMarketing.Action readonly updateApiKey!: (apiKey: string) => Promise<void>
    @smartMarketing.Action readonly activate!: () => Promise<void>
    @smartMarketing.Action readonly validate!: () => Promise<void>

    get enableOptions(): Array<{ label: string, value: boolean }> {
        return [
            { label: this.$t('yes').toString(), value: true },
            { label: this.$t('no').toString(), value: false },
        ]
    }

    get credentialsTypeOptions(): InputSelectOption[] {
        return this.supportedPlatforms.map(platform => ({
            label: this.$t(`forms.edit_smart_marketing_form.platforms.${platform}`).toString(),
            value: platform,
        }))
    }
}
